"use client";

import React from "react";

// Prevent app-level key handlers from blocking common clipboard/select shortcuts
// by intercepting them in the capture phase when focus is inside an editable element.
const isEditable = (el: Element | null) => {
  if (!el) return false;
  const tag = (el as HTMLElement).tagName?.toLowerCase();
  if (!tag) return false;
  if (tag === "input" || tag === "textarea") return true;
  const contentEditable = (el as HTMLElement).getAttribute?.("contenteditable");
  if (contentEditable === "true") return true;
  return false;
};

const KeyboardShortcutsFix: React.FC = () => {
  React.useEffect(() => {
    console.debug('[KeyboardShortcutsFix] mounted');
    const handler = (e: KeyboardEvent) => {
      try {
        if (!(e.metaKey || e.ctrlKey)) return;
        const key = (e.key || "").toLowerCase();
        // Common editing shortcuts we want to allow
        const allowed = new Set(["a", "c", "v", "x", "z", "y"]);
        if (!allowed.has(key)) return;

        const active = document.activeElement;
        if (isEditable(active as Element)) {
          // Stop other listeners in later phases from intercepting this event
          // without preventing the default browser action.
          e.stopImmediatePropagation();
        }
      } catch (err) {
        // swallow
      }
    };

    window.addEventListener("keydown", handler, { capture: true });
    return () => window.removeEventListener("keydown", handler, { capture: true } as any);
  }, []);

  return null;
};

export default KeyboardShortcutsFix;
